import { css } from 'linaria';

export const errorStateWrapper = css`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  @media (--only-mobile) {
    padding-top: var(--space-1000);
    padding-bottom: var(--space-1000);
  }
`;

export const errorStateImage = css`
  margin-bottom: var(--space-400);
`;

export const errorStateTitle = css`
  margin-bottom: var(--space-150);
`;
